import { useQuery } from "@tanstack/react-query";
import type { PsvMonitoringProgramStatus } from "@api/shared-runtime/psv-monitoring";
import { retryUnlessRecordUnavailable } from "@/common/utils/record-unavailable-error";
import { useTRPC } from "@/trpc";
import { isForbiddenError } from "./monitoring-format";

/** Pool id to monitoring status for the pools list. `visible` is false when
 * the column should be hidden: the feature is off, or the reader is
 * restricted to specific pools and the API refuses the read. */
export function usePoolMonitoringStatuses({
  organizationBusinessUnitId,
  enabled,
}: {
  organizationBusinessUnitId: string;
  enabled: boolean;
}) {
  const trpc = useTRPC();
  const query = useQuery({
    ...trpc.psv.monitoring.listPoolMonitoringStatus.queryOptions(
      { organizationBusinessUnitId },
      { retry: retryUnlessRecordUnavailable },
    ),
    enabled,
  });
  const statuses = new Map<string, PsvMonitoringProgramStatus>(
    (query.data ?? []).map((row) => [row.providerPoolId, row.status]),
  );
  return {
    visible: enabled && !isForbiddenError(query.error),
    statuses,
  };
}
